
import { Component, Vue } from 'vue-property-decorator';
import { KycRequests } from '@/api';
import UxLogs, { AccelerometerStatus, MediaData } from '@/api/ux_logs';
import ApiCancelError from '@/resources/error/ApiCancelError';
import ApiModalError from '@/resources/error/ApiModalError';
import { SensorData } from '@/store/modules/sensorMotion';

@Component
export default class Page extends Vue {
  public async created(): Promise<void> {
    try {
      // センサーログを送信
      const sensorData: SensorData[] = this.$store.getters['sensorMotion/stack'];
      const accelerometerStatus: AccelerometerStatus = this.$store.getters['sensorMotion/status'];
      const mediaData: MediaData[] = this.$store.getters['cameraMediaData/mediaData'];
      this.$store.commit('sensorMotion/clearSensorData');
      if (sensorData.length > 0) {
        await UxLogs.fetch(sensorData, accelerometerStatus, mediaData).catch((error: unknown): void => {});
      }
      // 完了情報を送信
      const kycRequestId: number = this.$store.getters['auth/kycRequestID'];
      await KycRequests.confirm(kycRequestId);
      // 完了状態へ移行
      this.$store.commit('completion/setComplete');
    } catch (error) {
      if (error instanceof ApiCancelError) {
        // キャンセルは握りつぶす
      } else if (error instanceof ApiModalError) {
        // clientRetryableで処理したエラーは握りつぶす
      } else throw error;
    }
  }
}
